import { render, staticRenderFns } from "./FourMatChart.vue?vue&type=template&id=454527e0&scoped=true&"
import script from "./FourMatChart.vue?vue&type=script&lang=js&"
export * from "./FourMatChart.vue?vue&type=script&lang=js&"
import style0 from "./FourMatChart.vue?vue&type=style&index=0&id=454527e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454527e0",
  null
  
)

export default component.exports